import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { WerklisteSection } from '@/components/sections/WerklisteSection';
import { werklisteNachJahr } from '@/lib/content/werkliste';

const seo = {
  title: 'Marlene Gujan Architektur AG | Werkliste',
  description: 'Entdecken Sie die beeindruckende Werkliste von Marlene Gujan Architektur AG in Igis, mit einer Vielzahl an einzigartigen Bauprojekten.',
  keywords: 'Werkliste, Bauprojekte, Architektur, Igis, Marlene Gujan, Architekturprojekte',
  canonicalUrl: 'https://www.gujan-architektur.ch/werkliste',
};

export default function Werkliste({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <WerklisteSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  return { props: { data: await werklisteNachJahr() }, revalidate: 300 };
}
